export default __webpack_public_path__ + "static/media/book.740a401e.svg";